import { useLoaderData } from 'react-router-dom'
import MainBtn from '../../modules/Button/MainBtn'
import ContactForm from '../../modules/ContactForm/ContactForm'
import MiniCard from '../../modules/MiniCard/MiniCard'
import PriceCard from '../../modules/PriceCard/PriceCard'
import Card from '../../modules/Cards/Card'
import './CoursePage.scss'
import { Helmet } from 'react-helmet';
import HowToStart from '../../modules/HowToStart/HowToStart'

export default function CoursePage(){
    const courseData = useLoaderData()
    

    return(
        <div className="CoursePage">
            <Helmet>
                <title>{courseData.meta.title}</title>
                <meta name="description" content={courseData.meta.description} />
                        
                            {/* Соціальні прев'ю (опціонально) */}
                <meta property="og:title" content={courseData.meta.title} />
                <meta property="og:description" content={courseData.meta.description} />
                <meta property="og:image" content="https://your-domain.com/img/preview.jpg" />
                <meta property="og:url" content={`https://smartum-pro.com/courses/${courseData.path}`} />
                
            </Helmet>
            <div className="course-container">
                <div className="top_section">
                    <div className="img_block">
                        <img src={courseData.course_img} alt="" />
                    </div>
                    
                    <div className="top_body">
                        <div className="top_text">
                        <h1>{courseData.name}</h1>
                        <p>{courseData.about}</p>
                       
                        </div>
                       <MainBtn text={'Безкоштовне перше заняття'} />
                    </div>
                </div>

                <div className="course-advantages">
                    <h2 className='title'>Чого навчить {courseData.name}?</h2>
                    <div className="advantages">
                        {courseData.advantages.map((el) => {
                            return <MiniCard key={el.title} title={el.title} text={el.about} img={el.icon} />
                        })}
                    {/* <MiniCard title={"Аналітичне і творче мислення"} text={"Одночасний розвиток роботи правої і лівої півкуль мозку допоможе вашій дитині вирішувати завдання різними способами"} img={"./i1.png"} /> */}
                    </div>
                    
                
                </div>

                <div className="bonus-btn">
                    <MainBtn text={"Спробувати безкоштовно"} />
                </div>

                <div className="about-block">
                <div className="age-groups">
                    <div className="age">
                       
                        <div className='age-content'>
                        <h2 className='title'>Як проходять заняття?</h2>
                        {courseData.details.map((el, index) => {
                            return(
                                <div key={index} className='age-category'>
                                {el}
                                </div>
                            ) 
                        })}
                        
                        </div>
                        
                        
                    </div>
                    <div className="age_img">
                        <img src={courseData.course_icon} alt="" />
                    </div>
                    
                    
                </div>
                <MainBtn text={"Записатись на заняття"} />
                </div>
                {/* <MainBtn text={"Записатись на заняття"} /> */}

                 <div className="contact-items">
                    <h2 className='title'>Формат занять</h2>
                
                    <div className="contact-item">
                
                        <Card title={'Online'} img={'https://thumbs.dreamstime.com/b/cartoon-girl-sitting-desk-laptop-front-her-ai-generated-image-cartoon-girl-sitting-desk-320199680.jpg'} about={'Онлайн заняття проходять через зум з використанням нашої платформи'} />
                                   
                        <Card title={'Ізмаїл'} img={'https://thumbs.dreamstime.com/b/holstentor-building-shown-cartoon-as-backdrop-happy-school-children-330041878.jpg'} about={'Наш центр знаходиться на просп. Миру, 25-б, 308 кабінет '} />
                        <Card title={'Білгород-Дністровський'} img={'https://img.freepik.com/premium-photo/cartoon-illustration-children-with-books-picture-them-reading-book_750792-1622.jpg'} about={'Наш центр знаходиться на вул.Героїв України 15'} />
                
                
                    </div>
                                                  
                                  
                </div>

                  <div>
                    <HowToStart />
                </div>

                <div className="price">
                    <h2 className='title'>Абонементи</h2>
                    <div className="price_items">
                        {courseData.price.map((el, index) => {
                            return <PriceCard key={index} name={el.name} number={el.number} price={el.price} discount={el.discount} />
                        })}
                        
                    </div>
                </div>

              

                <div className="contact-form">
                    <img src="/wave.svg" alt="" />
                     <div className="form_body">
                         <div className="form_text">
                             <h2>Запрошуємо вас на безкоштовне перше заняття онлайн або офлайн у наших центрах</h2>
                        </div>
                        <div className="form_item">
                        <ContactForm />
                        </div>
                                        
                    </div>
                </div>

            </div>
            
        </div>
    )
}